import React from "react";
import MyContext from "./my-context";

class MyProvider extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      treeList: "Deneme",
      store: {
        treeList: [],
        treeCount: null,
        treeClickChange: false,
      },
      storeToggle: {
        treeClickChange: false,
      },
      storeProcess: {
        successRowCount: 0,
        errorRowCount: 0,
        errorRowCodes: [],
        completeSuccess: false,
        completeError: false,
      },
      spinnerIsOpen: false,

      actions: {
        addTask: (title, check) =>
          this.setState({
            store: {
              treeList: title.treeList,
              treeCount: title.treecount,
              treeClickChange: check,
            },
          }),
        treeClickButton: (value) =>
          this.setState({
            storeToggle: {
              treeClickChange: value,
            },
          }),
        actionStartProcess: (value) =>
          this.setState({
            storeProcess: {
              successRowCount: value !== null ? value.successRowCount : 0,
              errorRowCount: value !== null ? value.errorRowCount : 0,
              errorRowCodes: value !== null ? value.errorRowCodes : [],
              completeSuccess: value !== null ? value.completeSuccess : false,
              completeError: value !== null ? value.completeError : false,
            },
          }),
        spinnerToggle: (value) =>
          this.setState({
            spinnerIsOpen: value,
          }),
      },
    };
  }

  render() {
    return (
      <MyContext.Provider
        value={{
          TreeList: this.state.treeList,
          setHeaderTitle: this.handleTitleChange,
          store: this.state.store,
          storeToggle: this.state.storeToggle,
          storeProcess: this.state.storeProcess,
          actions: this.state.actions,
          spinnerIsOpen: this.state.spinnerIsOpen,
        }}
      >
        {this.props.children}
      </MyContext.Provider>
    );
  }
}

export default MyProvider;
